import { useAlert } from "@/src/common/Alert";
import { MoreItem } from "@/src/common/MoreButton";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useLogout } from "@/src/OS/Login/useLogin";
import { useCallback } from "react";
import { useIntl } from "react-intl";

export function useLogoutMoreItem() {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const logout = useLogout();
  const alert = useAlert();
  const onLogout = useCallback(async () => {
    const shouldLogOut = await alert.confirm(
      intl_tokens.LogOut,
      intl.formatMessage({
        defaultMessage: "Are you sure you want to log out from this device?",
        description: "MyProfile:logoutbutton:alert:message",
      }),
      intl_tokens.LogOut
    );
    if (shouldLogOut) {
      logout();
    }
  }, [alert, intl, intl_tokens.LogOut, logout]);
  return {
    icon: "user-remove",
    color: "negative",
    label: intl_tokens.LogOut,
    onPress: onLogout,
  } as MoreItem;
}
